import React, { useContext, useRef } from "react";
import { CSSTransition } from "react-transition-group";
import { classNames } from "primereact/utils";

const AppInlineMenu = (props: any) => {
  const rawUserData = localStorage.getItem("user_data");
  let userData: any = null;
  userData = rawUserData ? JSON.parse(rawUserData) : null;
  const name =
    !window.cn(userData) && !window.cn(userData?.name)
      ? userData?.name.toUpperCase()
      : "";
  const menuRef = useRef(null);

  const isSlim = () => {
    return props.menuMode === "slim";
  };

  const isStatic = () => {
    return props.menuMode === "static";
  };

  const isSidebar = () => {
    return props.menuMode === "sidebar";
  };

  const isMobile = () => {
    return window.innerWidth <= 991;
  };

  return (
    <>
      {/* {!isMobile() && (isStatic() || isSlim() || isSidebar()) && (
                <div className={classNames('layout-inline-menu', { 'layout-inline-menu-active': props.activeInlineProfile })}>
                    <button className="layout-inline-menu-action p-link" onClick={props.onChangeActiveInlineMenu}>
                        <img src="/assets/images/avatar.png" alt="avatar" style={{ width: '44px', height: '44px' }} />
                        <span className="layout-inline-menu-text">{name}</span>
                        <i className="layout-inline-menu-icon pi pi-angle-down"></i>
                    </button>
                    <CSSTransition nodeRef={menuRef} classNames="p-toggleable-content" timeout={{ enter: 1000, exit: 450 }} in={props.activeInlineProfile} unmountOnExit>
                        <ul ref={menuRef} className="layout-inline-menu-action-panel">
                            <li className="layout-inline-menu-action-item">
                                <button className="p-link" onClick={logout}>
                                    <i className="pi pi-power-off pi-fw"></i>
                                    <span>Logout</span>
                                </button>
                            </li>
                        </ul>
                    </CSSTransition>
                </div>
            )} */}
    </>
  );
};

export default AppInlineMenu;
